import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { processSteps } from "@/mocks/siteData";

export default function ProcessSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="process" className="bg-background-100/70 py-20 md:py-28">
      <div className="mx-auto w-full max-w-3xl px-4 md:px-6">
        <Reveal>
          <SectionHeading kicker="Process" title="진행절차" />
        </Reveal>

        <div className="relative mt-14">
          <span className="absolute left-[19px] top-3 bottom-3 w-px bg-background-300/40" />
          <div className="space-y-4 md:space-y-5">
            {processSteps.map((step, i) => {
              const open = openIndex === i;
              return (
                <Reveal key={step.no} delay={i * 60}>
                  <div className="relative flex items-start gap-5">
                    <div
                      className={`relative z-10 mt-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border font-label text-sm transition-colors duration-300 ${
                        open
                          ? "border-primary-500 bg-primary-500 text-background-50"
                          : "border-primary-700/60 bg-background-50 text-primary-400"
                      }`}
                    >
                      {step.no}
                    </div>

                    <div
                      className={`flex-1 overflow-hidden rounded-lg border bg-background-50 transition-colors duration-300 ${
                        open
                          ? "border-primary-700/50"
                          : "border-background-200/70 hover:border-primary-700/50"
                      }`}
                    >
                      <button
                        type="button"
                        onClick={() => setOpenIndex(open ? -1 : i)}
                        aria-expanded={open}
                        className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left cursor-pointer md:px-6"
                      >
                        <div className="min-w-0">
                          <span className="font-label text-[10px] text-primary-500">
                            Step {step.no}
                          </span>
                          <h3 className="font-subheading mt-1.5 text-lg font-semibold text-foreground-950 md:text-xl">
                            {step.title}
                          </h3>
                          {!open ? (
                            <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                              {step.desc}
                            </p>
                          ) : null}
                        </div>
                        <span
                          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-all duration-300 ${
                            open
                              ? "rotate-180 border-primary-500 bg-primary-500 text-background-50"
                              : "border-background-300/60 text-foreground-500"
                          }`}
                        >
                          <i className="ri-arrow-down-s-line text-lg" />
                        </span>
                      </button>

                      <div
                        className={`grid transition-all duration-300 ease-out ${
                          open
                            ? "grid-rows-[1fr] opacity-100"
                            : "grid-rows-[0fr] opacity-0"
                        }`}
                      >
                        <div className="overflow-hidden">
                          <div className="px-5 pb-5 md:px-6 md:pb-6">
                            <p className="text-sm leading-relaxed text-foreground-600">
                              {step.desc}
                            </p>
                            <ul className="mt-3 space-y-2 border-t border-background-200/70 pt-4">
                              {step.details.map((detail) => (
                                <li
                                  key={detail}
                                  className="flex gap-2.5 text-xs leading-relaxed text-foreground-600"
                                >
                                  <span className="mt-[7px] h-1 w-1 shrink-0 rounded-full bg-primary-500" />
                                  <span>{detail}</span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}